import cx from 'classnames';
import * as React from 'react';
import SwiperCore, { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { Arrow } from './parts/Arrow';
import * as styles from './styles.css';
import './swiper.css';

// oxlint-disable-next-line react/rules-of-hooks
SwiperCore.use([Navigation]);

export interface ICarouselProps extends Swiper {
  className?: string;
  testId?: string;
  children: React.ReactElement[];
}

export const Carousel: React.FC<React.PropsWithChildren<ICarouselProps>> = props => {
  const { children, testId, className, ...swiperOptions } = props;

  // Элементы навигации храним в state, а не в ref: на первом рендере их ещё нет (null),
  // и swiper инициализирует навигацию без них. После маунта setState вызывает ре-рендер,
  // на котором swiper/react сам увидит новые prevEl/nextEl и доинициализирует навигацию
  // (см. needNavigationInit в swiper/esm/react/update-swiper.js).
  const [prevEl, setPrevEl] = React.useState<HTMLDivElement | null>(null);
  const [nextEl, setNextEl] = React.useState<HTMLDivElement | null>(null);

  const disabledClass = `${className}-button-disabled`;

  return (
    <div className={cx(styles['wrapper'], `${className}_wrapper`)} data-testid={testId}>
      <div className={styles['container']}>
        <Swiper
          navigation={{
            prevEl,
            nextEl,
            disabledClass,
          }}
          {...swiperOptions}
        >
          {React.Children.map(children, (child, index) => (
            <SwiperSlide key={index}>{child}</SwiperSlide>
          ))}
        </Swiper>
      </div>
      {swiperOptions.slidesPerView &&
        typeof swiperOptions.slidesPerView === 'number' &&
        React.Children.count(children) > swiperOptions.slidesPerView && (
          <>
            {/* Карусель всегда стартует с первого слайда, поэтому в SSR-разметке и до
                инициализации навигации левая стрелка сразу скрыта disabled-классом.
                Дальше этим классом управляет swiper (navigation.update). */}
            <Arrow direction={-1} ref={setPrevEl} className={disabledClass} />
            <Arrow direction={1} ref={setNextEl} />
          </>
        )}
    </div>
  );
};

Carousel.displayName = 'Carousel';

// oxlint-disable-next-line import/no-default-export
export default Carousel;
